// Modules
import React from 'react';

// Modules
// Material-ui
import { styled } from '@mui/material/styles';
import Typography, { type TypographyProps } from '@mui/material/Typography';

// Helpers
// Components
// Common components

const StyledTextOnlyButton = styled(Typography)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.mainColor,
  fontSize: '0.75rem',
}));

export default function TextOnlyButton({ children, className = '', ...props }: TypographyProps) {
  return (
    <StyledTextOnlyButton className={className} {...props}>
      {children}
    </StyledTextOnlyButton>
  );
}
